<template>
  <div class="upload">
    <div class="upload-container">
      <div class="common upload-top">
        <p class="common-title">上传资源</p>
        <div class="top-upload">
          <van-uploader
            accept="*"
            :after-read="afterRead"
            class="img-uploader"
            :preview-image="false"
          >
            <van-button class="top-btn" icon="plus" type="primary">上传文件</van-button>
          </van-uploader>

          <span>支持上传类型：图片、视频</span>
          <span>上传文件数量：50 单个文件大小：5GB</span>
        </div>
      </div>

      <div class="common upload-middle">
        <p class="middle-title common-title">上传列表</p>
        <div class="middle-list">
          <span>文件</span>
          <div class="middle-list_right">
            <span>状态</span>
            <span>操作</span>
          </div>
        </div>
        <div class="upload_container">
          <div class="upload-list" v-for="(item,index) in fileList" :key="index">
            <div class="upload-list_left">
              <img
                class="common-img"
                v-if="item.file.type=='video/mp4'"
                src="@/images/video.png"
                alt
              />
              <img class="common-img" v-else src="@/images/pict.png" alt />
              <span class="file-name">{{item.file.name}}</span>
            </div>
            <div class="upload-list_right">
              <img class="common-img" src="@/images/succ.png" alt />
              <van-button type="default" class="delet_btn" @click="deletFile(index)">
                <img class="common-img" src="@/images/dele.png" alt />
              </van-button>
            </div>
          </div>
        </div>
        <p v-if="!fileList.length" class="middle-operate">请上传资源</p>
      </div>
      <div class="common upload-bottom">
        <span class="common-title">温馨提示</span>
        <p>1. 发布馆藏需拥有上传内容的“原创著作权”，知晓并同意</p>
        <p>2. 上传过程中请要关闭页面或删除原始照片和视频。</p>
      </div>
    </div>

    <div class="flex upload-btn">
      <div class="check-btn" @click="uploadnext">
        <span>下一步</span>
        <span class="dot">.</span>
        <span>资源审核</span>
      </div>
    </div>
    <!-- 选择文件弹窗 -->

    <!-- 导航 start -->
    <div class="naviPosition" />
    <div class="digNavigate">
      <router-link class="navItm" :to="{ name: 'Waphome' }">
        <img src="../../../images/home.png" class="img-normal" />
        <img src="../../../images/home_select.png" class="img-active" />
        <label>首页</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Waplist' }">
        <img src="../../../images/res.png" class="img-normal" />
        <img src="../../../images/res_select.png" class="img-active" />
        <label>{{clients.collectionTheme?clients.collectionTheme:'特藏'}}</label>
      </router-link>
      <router-link class="navItm active" :to="{ name: 'Wapcertified' }">
        <img src="../../../images/upload.jpg" class="img-normal" />
        <img src="../../../images/upload_select.jpg" class="img-active" />
        <label>上传</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Wapuser' }">
        <img src="../../../images/use.png" class="img-normal" />
        <img src="../../../images/use_select.png" class="img-active" />
        <label>我的</label>
      </router-link>
    </div>
    <!-- 导航 end -->
  </div>
</template>
<script>
import SparkMD5 from "spark-md5";
import api from "../../../api/home.js";
import {
  getUploadInfo,
  client,
  resourceCheckMd5,
  getByTenantId,
  collectionUpload
} from "@/api/upload";
import { dateFormat } from "@/utils/validate";
export default {
  data() {
    return {
      imgKey: [],
      list: [1, 2, 3, 4],
      fileList: [],
      httpupload: null,
      checkpoints: {},
      clients: {}
    };
  },
  created() {
    this.requestclient();
  },
  methods: {
    //获取应用信息
    requestclient() {
      const that = this;
      api
        .requestclient({ tenantId: this.$store.getters.tenantId })
        .then(r => {
          that.clients = r.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    deletFile(index) {
      console.log("item", index);
      this.fileList.splice(index, 1);
    },
    async uploadnext() {
      if (this.fileList.length === 0) {
        this.$message({
          message: "请选择文件",
          type: "error"
        });
        return;
      }
      //   const index = this.fileList.findIndex(element => {
      //     return element.status !== '完成'
      //   })
      //   if (index !== -1) {
      //     this.$message({
      //       message: '请等待上传完成',
      //       type: 'warning'
      //     })
      //     return
      //   }
      var resourcesList = [];
      this.fileList.forEach(element => {
        const md5Name =
          element.md5 +
          element.name
            .substring(element.name.lastIndexOf("."), element.name.length)
            .toLowerCase();
        const name = element.name.substring(0, element.name.lastIndexOf("."));
        resourcesList.push({
          resourceCloudName: md5Name, // 资源在云端的名称
          resourceCreateTime: dateFormat(element.createtime), // 资源的创建时间
          resourceMd5: element.md5,
          resourceName: name,
          resourceFileName: element.name, // 资源源名称
          resourcePath:
            element.dir.charAt(element.dir.length - 1) === "/"
              ? element.dir + md5Name
              : element.dir, // dir + 文件名，如："java/mrms/img/" + "abc.jpg"
          resourceSize: element.size,
          resourceTime: element.resourceTime ? element.resourceTime : 0, // 音视频资源的时长
          resourceUpdateTime: dateFormat(element.createtime), //  资源的最后编辑时间
          resourceUploadBegin: element.uploadBeginTime,
          resourceUploadEnd: element.uploadEndTime
        });
      });
      this.nextButton = true;
      const res = await collectionUpload({
        collectionVOs: [
          {
            collectionName: "",
            status: this.nextStatus,
            resources: resourcesList
          }
        ],
        tenantId: this.$store.getters.tenantId
      });
      this.nextButton = false;
      if (res.data) {
        this.$router.push({
          path: "/wap/sourceupload/check", //'/single',
          query: {
            collectionId: res.data
          }
        });
        this.$emit("uploadNext");
      }
    },
    onChange(file, fileList) {
      console.log("file", file, fileList);
    },
    afterRead(file) {
      console.log("fileList", this.fileList);
      console.log("file", file);
      // if (file.status === 'ready') {
      // const _this = this

      // if (!this.checkFile(file.raw)) {
      //   return
      // }
      const fileprogress = this.fileList.find(
        list => list.uid === file.file.lastModified
      );
      if (!fileprogress) {
        const item = {
          name: file.file.name,
          uid: file.file.lastModified,
          type: file.file.type,
          size: file.file.size,
          md5: "",
          file: file.file,
          createtime: file.file.lastModified,
          dir: "",
          progress: 0,
          status: "准备"
          // uploadBeginTime: dateFormat(new Date().getTime()),
          // webkitRelativePath: file.raw.webkitRelativePath
        };
        this.fileList.push(item);
        console.log("this.fileList", this.fileList);
        const uploadList = this.fileList.filter(element => {
          console.log(element.status);
          return element.status === "正在上传";
        }); // 生成数组

        if (uploadList.length < 5) {
          item.status = "正在上传";

          this.createMd5Url(item);
        }
      }
      //   } else {
      //     console.log('noready')
      //   }
    },
    // 计算MD5
    createMd5Url(file) {
      const _this = this;
      const blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      const chunkSize = 2097152;
      const chunks = Math.ceil(file.size / chunkSize);
      let currentChunk = 0;
      const spark = new SparkMD5.ArrayBuffer();
      const fileReader = new FileReader();
      // console.log('计算MD5...')
      file.cmd5 = true;

      fileReader.onload = e => {
        spark.append(e.target.result); // Append array buffer
        currentChunk =
          currentChunk + 10 < chunks ? currentChunk + 10 : currentChunk + 1;

        if (currentChunk < chunks) {
          // console.log(`第${currentChunk}分片解析完成, 开始第${currentChunk +1} / ${chunks}分片解析`);
          // let percent = Math.floor(currentChunk / chunks * 100);
          // console.log(percent);
          // file.cmd5progress = percent;
          loadNext();
        } else {
          const md5 = spark.end();

          spark.destroy(); // 释放缓存
          file.md5 = md5;
          _this.checkMd5(file);
        }
      };
      fileReader.onerror = () => {
        console.log("失败");
      };

      const loadNext = () => {
        const start = currentChunk * chunkSize;
        const end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;

        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
      };

      loadNext();
    },
    async checkMd5(item) {
      const res = await resourceCheckMd5({
        md5Codes:
          item.md5 +
          item.file.name.substring(
            item.file.name.lastIndexOf("."),
            item.file.name.length
          ),
        tenantId: this.$store.getters.tenantId
      });
      console.log(res);
      if (!res.data) {
        this.checkMd5(item);
        return;
      }
      if (res.data) {
        if (res.data.length > 0) {
          if (!res.data[0].exist) {
            item.dir = res.data[0].dir;
            item.uploadBeginTime = dateFormat(new Date().getTime());
            item.status = "正在上传";
            this.fileupload(item.file);
          } else {
            const existResource = res.data[0].existResource;

            item.dir = res.data[0].existResource.resourcePath;
            item.progress = 100;
            item.uploadDescript = "MD5重复";
            item.uploadBeginTime =
              existResource.resourceUploadBegin !== ""
                ? existResource.resourceUploadBegin
                : dateFormat(new Date().getTime());
            item.status = "完成";
            item.uploadEndTime =
              existResource.resourceUploadEnd !== ""
                ? existResource.resourceUploadEnd
                : dateFormat(new Date().getTime());
            this.toUpload();
          }
        }
      }
    },
    async fileupload(file) {
      const that = this;
      console.log("file1111", file);
      const fileprogress = that.fileList.find(list => {
        return list.uid === file.lastModified;
      });

      if (
        fileprogress.type.indexOf("video") !== -1 ||
        fileprogress.type.indexOf("audio") !== -1
      ) {
        var audio = new Audio();
        audio.src = URL.createObjectURL(file);
        // 元数据已加载
        audio.addEventListener("loadedmetadata", function(e) {
          fileprogress.resourceTime = audio.duration;
        });
      }

      this.putUpload(fileprogress, file);
    },
    async putUpload(fileprogress, file) {
      const that = this;
      if (that.httpupload === null) {
        const res = await getUploadInfo();

        that.httpupload = client(res.data);
      }

      const fileSuffix = fileprogress.name
        .substring(fileprogress.name.lastIndexOf(".") + 1)
        .toLowerCase();
      return await that.httpupload
        .multipartUpload(
          fileprogress.dir + fileprogress.md5 + "." + fileSuffix,
          file,
          {
            parallel: 5,
            partSize: 1024 * 1024,

            progress: function(p, checkpoint) {
              if (checkpoint) {
                fileprogress.uploadId = checkpoint.uploadId;
                that.checkpoints[checkpoint.uploadId] = checkpoint;
              }

              // fileprogress.progress = parseInt(p * 100)
              const progress = parseInt(p * 100);
              if (fileprogress.progress < progress) {
                fileprogress.progress = parseInt(p * 100);
              }
            }
            // meta: { year: 2020, people: 'dev' },
            // mime: this.file.type
          }
        )
        .then(result => {
          if (result.res.status === 200) {
            fileprogress.status = "完成";
            fileprogress.uploadDescript = "";
            fileprogress.uploadEndTime = dateFormat(new Date().getTime());
            delete that.checkpoints[fileprogress.uploadId];
            that.toUpload();
          }
        })
        .catch(err => {
          console.error(err);
          fileprogress.uploadDescript = "上传中断";
          fileprogress.progress = fileprogress.progress - 1;
          // eslint-disable-next-line require-atomic-updates
          fileprogress.status = "失败";
          delete that.checkpoints[fileprogress.uploadId];
          that.toUpload();
        });
    },

    toUpload() {
      const index = this.fileList.findIndex(element => {
        return element.status === "准备";
      });

      if (index !== -1) {
        this.createMd5Url(this.fileList[index]);
      }
    },
    toCheck() {
      this.$router.push({
        path: "/wap/sourceupload/check"
      });
    },
    open() {
      this.$alert("请等待文件上传完成", "提示", {
        customClass: "message-out",
        confirmButtonText: "知道了",
        center: true,
        callback: action => {
          this.$message({
            type: "info",
            message: `action: ${action}`
          });
        }
      });
    }
  }
};
</script>
<style src="@/styles/wap.scss" lang="scss" scoped></style>
<style scoped lang="scss">
.common-title {
  font-size: 0.4444rem;
  color: #4c70e8;
  font-weight: 700;
}
.upload_container {
  overflow: hidden;
  max-height: 2.6852rem;
  overflow-y: scroll;
}
.delet_btn {
  border: none;
  height: 30px;
  padding: 0;
}
.van-button__icon {
  display: none;
}
.van-button__text {
  margin-left: 0;
  color: #ffffff !important;
}
.upload-list {
  width: 100%;
  font-size: 0.2407rem;
  display: flex;
  justify-content: space-between;
  height: 0.8333rem;
  overflow: hidden;
  .file-name {
    width: 4.25rem;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .upload-list_left {
    line-height: 0.5556rem;
    display: flex;
    align-items: center;
  }
  .upload-list_right {
    line-height: 0.5556rem;
    display: flex;
    align-items: center;
  }
  .common-img {
    width: 0.5926rem;
    height: 0.5926rem;
    display: inline-block;
  }
}
.upload-container {
  box-sizing: border-box;
  width: 100%;
  /* padding-left: 0.3333rem;
        padding-right: 0.3333rem;
        padding-top: 0.3704rem; */
  padding: 0.3704rem 0.3333rem 0.3241rem 0.3333rem;
  background: #eee;
}

.flex {
  display: flex;
}

.common {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 0.0463rem 0.1389rem 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.1111rem;
}
.upload-top {
  box-sizing: border-box;
  /* padding-left: 0.3704rem; */
  height: 5.037rem;
  margin-bottom: 0.2778rem;
}
.upload-top p:first-child {
  height: 1.2222rem;
  line-height: 1.2222rem;
  padding-left: 0.3704rem;
  font-size: 0.4444rem;
  font-weight: 700;
  // background: rgba(0, 0, 0, 0.29);
  /* opacity: 0.29; */
  color: #4c70e8;
}
.top-upload {
  width: 8.5926rem;
  height: 3.4259rem;
  border: 1px dashed #7b84a1;
  /* margin-top: ; */
  margin: 0 auto;
  text-align: center;
}
.top-btn {
  width: 2.7963rem;
  height: 0.7037rem;
  background: #4c70e8;
  border-radius: 0.1111rem;

  text-align: center;
  font-size: 0.3333rem;
  font-weight: 700;
  color: #ffffff;
  line-height: 0.7037rem;
  margin: 0 auto;
  margin-top: 0.8056rem;
  margin-bottom: 0.3333rem;
  border: none;
}
.upload-top span {
  display: inline-block;
  width: 100%;
  height: 0.5185rem;
  text-align: center;
  line-height: 0.5185rem;
  font-size: 0.3333rem;
  color: #7b84a1;
}
.upload-middle {
  box-sizing: border-box;
  height: 4.4259rem;
  margin-bottom: 0.2778rem;
  padding-left: 0.3704rem;
  padding-top: 0.3704rem;
  padding-right: 0.3704rem;
}
.middle-list {
  margin-top: 0.4352rem;
  width: 100%;
  height: 0.4074rem;
  border-top: 1px solid #f3f4f9;
  border-bottom: 1px solid #f3f4f9;
  display: flex;
  justify-content: space-between;
}
.middle-operate {
  font-size: 0.2407rem;
  color: #7b84a1;
  margin-top: 1.1852rem;
  margin-left: 3.8333rem;
}
.middle-list span {
  font-size: 0.3333rem;
  font-weight: 400;
  color: #7b84a1;
  line-height: 0.4074rem;
  opacity: 0.5;
}
.middle-list_right span:nth-child(1) {
  margin-right: 0.5185rem;
}
.middle-list_right span:nth-child(2) {
  margin-right: 0.6019rem;
}
.upload-list_right img:nth-child(1) {
  margin-right: 0.5463rem;
}
.upload-list_right img:nth-child(2) {
  margin-right: 0.7222rem;
}
.upload-bottom {
  box-sizing: border-box;
  font-size: 0.3333rem;
  padding: 0.3704rem;
}
.upload-bottom p {
  font-size: 0.3333rem;
  font-weight: 400;
  color: #1f233e;
  padding-top: 0.3704rem;
}
.upload-btn {
  width: 100%;
  height: 1.6667rem;
  background: #ffffff;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding-left: 0.3333rem;
  padding-right: 0.3333rem;
  position: absolute;
  bottom:1.6667rem;
}
.check-btn {
  width: 100%;
  height: 0.9259rem;
  background: #4c70e8;
  border-radius: 0.1111rem;
  text-align: center;
  line-height: 0.9259rem;
  /* justify-content: center ;
        align-items: center; */
}
.check-btn span {
  font-size: 0.3333rem;
  font-weight: 400;
  color: #ffffff;
}
.check-btn span:first-child {
  font-weight: 700;
}
.dot {
  position: relative;
  top: -0.0556rem;
}
</style>
<style>
.message-out {
  width: 7.2778rem !important;
  border-radius: 0.0463rem;
  height: 4.3889rem;
}
</style>